<div *ngIf="dataObj && dataObj.domain">
  <pru-header appName="{{ dataObj.appName }}" accessOptions="auth" [logoutFn]="maLogoutFn" [domain]="dataObj.domain"
    [alertsConfig]="alertsConfig" isCustomer="true" [navJson$]="navigation" [profileName]="profileName"></pru-header>
</div>

<div *ngIf="!configError" class="color-scheme-gray pb-4">
  <div class="main-container" id="mainContent" role="main">
    <h1 class="sr-only">My Accounts</h1>
    <pru-messages></pru-messages>
    <topbucket></topbucket>

    <link-banner *ngIf="!redesign"></link-banner>

    <!-- <ng-container *featureToggle="'ricWcEnabled'">
      <pru-ric-banner *ngIf="usr_rspar" [ssoid]="123456" [retirementDomain]="retirementDomain"></pru-ric-banner>
    </ng-container> -->

    <ng-container *featureToggle="'ric3WcEnabled'">
      <ric-wc *ngIf="usr_rspar"></ric-wc>
    </ng-container>

    <!-- <ng-container *featureToggle="'ricWc2Enabled'">
      <ric-calculator></ric-calculator>
    </ng-container> -->

    <ng-container *ngIf="_genericService.showDems">
      <pru-marketing-messages [appName]="'MyPru'" [slotName]="'AccountsSummaryPage_BelowAccountSummary'"
        [topMarginRequired]="'Y'" [retirementLink]="_genericService.retCntrUrl">
      </pru-marketing-messages>
    </ng-container>


    <div class="mt-4" *ngIf="!redesign">
      <div class="container">
        <div class="row mb-3">
          <div class="col-sm-12">
            <h2 [attr.data-qa]="'my-prudential-accounts-title'" class="h2 product-subtitle">My Prudential Accounts</h2>
          </div>
        </div>
      </div>
    </div>
    <h2 class="sr-only" *ngIf="redesign">My Prudential Accounts</h2>
    <ng-container *ngIf="dataObj && appConfig">
      <ng-container *ngFor="let obj of appConfig; let index = index">
        <ng-container *ngIf="obj.visibility">
          <app-dycomponent [serviceName]="obj.serviceFlag"
            [isAggregationBucket]="obj.aggregationBucket ? 'true' : 'false'" [entitlement]="obj.entitlement"
            [templateName]="obj.templateName" [serviceURL]="obj.service" [shouldAggregate]="obj.genericService">
          </app-dycomponent>
          <!-- <lo-temp dyIndex="{{index}}" agg="{{obj.aggregationBucket ? 'true' : 'false'}}" templateName="{{obj.templateName}}" serviceURL="{{obj.service}}" genericService="{{obj.genericService}}" applicationName="{{dataObj.appName}}" entitlement="{{obj.entitlement}}">
          </lo-temp> -->
        </ng-container>
      </ng-container>

      <ng-container *ngIf="userHasSia">
        <app-accounts [productType]="'SIA'" [clearCache]="true"></app-accounts>
      </ng-container>
      <!-- <ng-container *ngIf="user_pruco">
        <pruco></pruco>
      </ng-container> -->
      <ng-container *ngIf="usr_rspar">
        <retirement-component></retirement-component>
      </ng-container>
      <ng-container *ngIf="user_pma">
        <pma></pma>
      </ng-container>

      <!-- <pru-marketing-pod *ngIf="redesign"></pru-marketing-pod> -->

      <ng-container *ngIf="usr_ext_agg">
        <aggregated-external></aggregated-external>
      </ng-container>
      <div class="container" *ngIf="!usr_FEDERATED">
        <div class="row">
          <div class="col-sm-12">
            <p class="title-content pt-3 text-right-lg">
              <a [attr.data-qa]="'add-other-pru-accounts-link'" [href]="'/wps/myportal/iam/link-account#/link'"
                class="auth-link sm-block">
                <span class="fa fa-fw fa-plus-circle"></span>Connect other Prudential accounts</a>
            </p>
          </div>
        </div>
      </div>
      <bottombucket></bottombucket>
    </ng-container>
  </div>
</div>
<div *ngIf="configError">
  <config-error></config-error>
</div>

<footer-comp></footer-comp>

<pru-backtotop></pru-backtotop>
<ng-container *ngIf="usr_rspar">
  <js-interstitial *featureToggle="'jsInterstitial'"
    [firstName]="homeinitService.appConfiguration.profile.firstName ? homeinitService.appConfiguration.profile.firstName: ''"
    [lastName]="homeinitService.appConfiguration.profile.lastName ? homeinitService.appConfiguration.profile.lastName : ''">
  </js-interstitial>
</ng-container>
<session-timeout [userConfig]="configOfTimeout"></session-timeout>